module.exports = __webpack_public_path__ + "img/HG4301-01.e6beb273.jpg";